(() => {
  const init = (root) => {
    if (root.dataset.cardsReady) return;
    root.dataset.cardsReady = 'true';
    const cards = [...root.querySelectorAll('[data-card]')];
    const set = (card, open) => {
      const button = card.querySelector('[data-card-toggle]');
      const details = card.querySelector('[data-card-details]');
      if (!button || !details) return;
      button.hidden = false;
      button.setAttribute('aria-expanded', String(open));
      button.firstElementChild.textContent = open ? button.dataset.closeLabel : button.dataset.openLabel;
      details.hidden = !open;
    };
    const open = (card) => {
      if (root.dataset.oneOpen === 'true') cards.forEach(other => { if (other !== card) set(other, false); });
      set(card, true);
    };
    cards.forEach(card => {
      const button = card.querySelector('[data-card-toggle]');
      if (!button) return;
      set(card, false);
      button.addEventListener('click', () => button.getAttribute('aria-expanded') === 'true' ? set(card, false) : open(card));
      card.addEventListener('keydown', event => {
        if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
          event.preventDefault(); set(card, false); button.focus();
        }
      });
      if (root.dataset.trigger !== 'hover') return;
      card.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') open(card); });
      card.addEventListener('pointerleave', () => { if (!card.contains(document.activeElement)) set(card, false); });
      card.addEventListener('focusin', event => { if (!card.contains(event.relatedTarget)) open(card); });
      card.addEventListener('focusout', event => { if (!card.contains(event.relatedTarget) && !card.matches(':hover')) set(card, false); });
    });
  };
  const start = (scope) => scope.querySelectorAll('[data-park-cards]').forEach(init);
  start(document);
  if (!window.parkCardsSectionLoadRegistered) {
    window.parkCardsSectionLoadRegistered = true;
    document.addEventListener('shopify:section:load', event => start(event.target));
  }
})();
